// initialed state
import StorageService from '@/utils/storage-service';
const storage = StorageService.getStorage();
export const DID_SEE_UTM_INTRO = 'didSeeUtmIntro';
export const IS_NOTIFICATIONS_PINNED = 'isNotificationsPinned';
export const IS_PROJECT_MENU_PINNED_KEY = 'isProjectMenuPinned';
export const SEEN_INTERFACE_EXPLANATION = 'seenInterfaceExplanation';
export const DISMISSED_SPACE_TAB_EXPLANATION = 'dismissedSpaceTabExplanation';
export const DISMISSED_PLACEMENT_TAB_EXPLANATION = 'dismissedPlacementTabExplanation';

export const initialState = () => ({
	showInspirationCenter: false,
	didSeeUtmIntro: StorageService.getStorageValueWithFallback(storage, DID_SEE_UTM_INTRO, false),
	isNotificationsPinned: StorageService.getStorageValueWithFallback(storage, IS_NOTIFICATIONS_PINNED, false), //todo-new-ui: verify with product the default value
	isProjectMenuPinned: StorageService.getStorageValueWithFallback(storage, IS_PROJECT_MENU_PINNED_KEY, true),
	seenInterfaceExplanation: StorageService.getStorageValueWithFallback(storage, SEEN_INTERFACE_EXPLANATION, false),
	dismissedSpaceTabExplanation: StorageService.getStorageValueWithFallback(storage, DISMISSED_SPACE_TAB_EXPLANATION, false),
	dismissedPlacementTabExplanation: StorageService.getStorageValueWithFallback(storage, DISMISSED_PLACEMENT_TAB_EXPLANATION, false),
});

const state = initialState();

export default state;
